import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import HedefNakliyeFiyatInput from "../sections/payment/inputs/HedefNakliyeFiyatInput";
import FiyatOnerBtn from "../sections/payment/others/FiyatOnerBtn";
import NakliyeFiyatYayinlansinCheckbox from "../sections/payment/inputs/NakliyeFiyatYayinlansinCheckbox";
import OdemeSekliInput from "../sections/payment/inputs/OdemeSekliInput";
import YakitOraniInput from "../sections/payment/inputs/YakitOraniInput";
import KomisyonDurumuInput from "../sections/payment/inputs/KomisyonDurumuInput";
import KomisyonOraniInput from "../sections/payment/inputs/KomisyonOraniInput";
import FiyatlandirmaTipiInput from "../sections/payment/inputs/FiyatlandirmaTipiInput";
import KomisyonCalculator from "../sections/payment/others/KomisyonCalculator";
import BtnOutline from "../../shared/button/BtnOutline";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { scrollToTop } from "../../../helper/scrollToTop";
import OdemeSekliDigerAciklamaInput from "../sections/payment/inputs/OdemeSekliDigerAciklamaInput";
import { showModal } from "../../../features/modal/modalSlice";
import YakitDurumuInput from "../sections/payment/inputs/YakitDurumuInput";
import { setErrors } from "../../../features/addLoad/addLoadSlice";
import submitLoadPermission from "../../../helper/load/submitLoadPermission";
import { setLoadItemData } from "../../../features/loadList/loadListSlice";
import YukVerenFiyatInput from "../sections/payment/inputs/YukVerenFiyatInput";

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .title-container {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .input-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: 30px 0 0 40px;

    .input-grp {
      display: flex;
      align-items: center;
      gap: 15px;
    }

    .margin-left {
      margin-left: 20px;
    }
  }

  .bottom-btn-container {
    width: 100%;
    padding: 50px;
    display: flex;
    justify-content: space-between;

    .icon {
      fill: var(--color-main);
      font-size: 1.6rem;
    }

    span {
      color: ${({ theme }) => theme.mainTextColor};
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-xl);
    }
  }
`;

const OdemeSection = ({ setPhase, yukKayit }) => {
  const { theme } = useSelector((state) => state.layout);

  const {
    route,
    aracData,
    paymentData,
    yukData,
    paketlemeData,
    routeDistance,
    selectedProjectAddLoad
  } = useSelector((state) => state.addLoad);

  const dispatch = useDispatch();
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
  const rld = JSON.parse(storage.getItem("rld"))

  const handleClick = () => {
    //! buradan true gelirse iyi false gelirse error verilmeli
    if (
      submitLoadPermission(
        route,
        aracData,
        paymentData,
        yukData,
        paketlemeData,
        routeDistance,
        selectedProjectAddLoad,
        true
      )
    ) {
      // dispatch(showModal("addLoadYuklemeSecenekleri"));
      dispatch(showModal("addLoadYetkiliBilgiForm"));
      dispatch(setLoadItemData(route))
      storage.removeItem("routeData");
    } else {
      dispatch(setErrors(true));
      dispatch(showModal("loadPermissionError"))

    }
    // dispatch(showModal("addLoadYuklemeSecenekleri"))
  };
  
  return (
    <Container>
      <div className="title-container">
        <svg
          width="18"
          height="24"
          viewBox="0 0 18 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_1213_935)">
            <path
              d="M4.488 0H6.899V6.2C9.333 5.32 11.789 4.395 14.24 3.507V5.5C11.786 6.38 9.351 7.275 6.899 8.155V9.182C9.35 8.294 11.806 7.369 14.24 6.489V8.467C11.807 9.372 9.346 10.247 6.899 11.137V21.414C8.5393 21.2022 10.0962 20.567 11.4165 19.5709C12.7368 18.5748 13.775 17.2521 14.429 15.733L14.453 15.671C14.9492 14.5071 15.203 13.2543 15.199 11.989V11.981H17.701V12.361C17.6491 14.1182 17.2125 15.8427 16.422 17.413L16.454 17.344C15.7832 18.6748 14.8766 19.8729 13.778 20.88L13.769 20.888C11.5809 22.8975 8.71685 24.0103 5.746 24.005C5.303 24.005 4.866 23.981 4.435 23.934L4.488 23.939V12.019C2.982 12.549 1.498 13.102 0 13.639V11.719C1.501 11.171 3.006 10.628 4.488 10.061V9.042C2.995 9.552 1.498 10.124 0 10.655V8.745C1.491 8.185 3.009 7.651 4.488 7.079V0Z"
              fill={theme === "dark" ? "#F4F4F4" : "#3D3D3B"}
            />
          </g>
          <defs>
            <clipPath id="clip0_1213_935">
              <rect width="18" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <h4>Ödeme Bilgileri</h4>
      </div>
      <div className="input-list">
        <div className="input-grp">
          <FiyatlandirmaTipiInput
            data={paymentData}
            name="fiyatlandirmaTipi"
            isRequired={true}
          />
          {(rld !== ("ee37e5e8-6aa5-46cd-b718-2dd45e4f0d84" || "3d3aaf05-3ce1-4bfe-95d4-6feae88b1228")) &&
            <HedefNakliyeFiyatInput
              data={paymentData}
              name={"hedefNakliyeFiyat"}
              isRequired={false}
            />
          }
          
          <YukVerenFiyatInput
            data={paymentData}
            name={"yukverenFiyat"}
            isRequired={false}
          />
          
          
          {/* <FiyatOnerBtn handleClick={() => dispatch(showModal("suggestPrice"))}/> */}
        </div>
        <div className="margin-left">
          <NakliyeFiyatYayinlansinCheckbox
            data={paymentData}
            name="fiyatYayinlansinMi"
            isRequired={false}
          />
        </div>
        <OdemeSekliInput
          data={paymentData}
          name="odemeSekli"
          isRequired={false}
        />
        {paymentData?.odemeSekli?.value === 9 && (
          <OdemeSekliDigerAciklamaInput
            data={paymentData}
            name="odemeSekliDigerAciklama"
            isRequired={false}
          />
        )}

        <div className="input-grp">
          <YakitDurumuInput
            data={paymentData}
            isRequired={false}
            name={"yakitDurumu"}
          />
          {(paymentData?.yakitDurumu?.value === 1 ||
            paymentData?.yakitDurumu?.value === 2) && (
            <YakitOraniInput
              data={paymentData}
              isRequired={true}
              name={"yakitOrani"}
              labelText={`Yakıt Oranı${
                paymentData?.yakitDurumu?.value === 1
                  ? "(%)"
                  : paymentData?.yakitDurumu?.value === 2 && "(TL)"
              }`}
            />
          )}
        </div>
        <div className="input-grp">
          <KomisyonDurumuInput
            data={paymentData}
            isRequired={false}
            name={"komisyonDurumu"}
          />
          {paymentData?.komisyonDurumu?.value !== 0 && (
            <KomisyonOraniInput
              data={paymentData}
              isRequired={false}
              name={"KomisyonOrani"}
              labelText={`Komisyon Miktarı ${
                paymentData?.komisyonDurumu?.value === 1
                  ? "(%)"
                  : paymentData?.komisyonDurumu?.value === 2 ? "(TL)": ""
              }`}
            />
          )}
          {/* {
              (paymentData.komisyonDurumu.value === 1 || paymentData.komisyonDurumu.value === 2) &&
              <KomisyonCalculator komisyonValue={paymentData.komisyonMiktari} komisyonType={paymentData.komisyonDurumu.value} nakliyeFiyat={paymentData.hedefNakliyefiyat}/>
            } */}
        </div>
      </div>
      <div className="bottom-btn-container">
        <BtnOutline
          height={"40px"}
          width={"120px"}
          radius={"10px"}
          handleClick={() => {
            setPhase({ id: 5, name: "Araç" });
            scrollToTop();
          }}
        >
          <MdKeyboardArrowLeft className="icon" />
          <span>Araç</span>
        </BtnOutline>
        {!yukKayit &&
          <BtnOutline
            height={"40px"}
            width={"120px"}
            radius={"10px"}
            handleClick={handleClick}
          >
            <span>Tamamla</span>
            <MdKeyboardArrowRight className="icon" />
          </BtnOutline>
        }
        
      </div>
    </Container>
  );
};

export default OdemeSection;
